import React from "react";
import "./Header.css";

const Header = () => {
  return (
    <header className="header">
      <h1 className="header-title">To Do List</h1>
    </header>
  );
};
export default Header;
